import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

/** Valores por defecto — se usan si Firestore no tiene documento aún */
export const CONFIG_DEFAULTS = {
  homeTitulo:       'Tu lugar para vos en Formosa está aquí',
  homeSubtitulo:    'Cada propiedad la acerca un corredor inmobiliario asociado a la CIF',
  quienesTitulo:    'Seguridad y Profesionalismo en cada oferta',
  quienesTexto:     'FormoProp es una página donde las ofertas que usted ve, son presentadas por los Corredores Inmobiliarios de la Cámara Inmobiliaria de Formosa, diseñada para brindarte tranquilidad a la hora de buscar tu próximo hogar o inversión.',
  venderTitulo:     'Tu propiedad merece un profesional',
  venderSubtitulo:  'Los corredores asociados a la Cámara Inmobiliaria de Formosa (CIF) están capacitados y habilitados para gestionar la venta de tu propiedad con total seguridad jurídica.',
  footerSubtitulo:  'Encontrá tu próximo hogar con seguridad.',
  footerDisclaimer: 'Todas las medidas enunciadas son meramente orientativas; las medidas exactas serán las que se expresen en el respectivo título de propiedad de cada inmueble. Todas las fotos, imágenes y videos son meramente ilustrativos y no contractuales. Los precios enunciados son meramente orientativos y no contractuales. Cada corredor es responsable de la publicación y los derechos de autor.',
  remateDisclaimer: 'La información publicada sobre cada remate es meramente orientativa y de difusión. En todos los casos rige exclusivamente lo dispuesto en el edicto judicial y las condiciones fijadas por el juzgado interviniente. Las fechas, bases y condiciones pueden ser modificadas o suspendidas por orden judicial. Consultá al martillero a cargo y verificá los datos en el expediente antes de participar.',
};

/** Cache a nivel de módulo — se lee una sola vez por sesión */
let _cache = null;

/** Limpia el cache (llamar después de guardar desde el panel admin) */
export function invalidarCacheConfig() { _cache = null; }

/**
 * Hook que devuelve la configuración del sitio.
 * Primer render usa defaults; actualiza cuando llega Firestore.
 */
export function useConfigSitio() {
  const [config, setConfig] = useState(_cache || CONFIG_DEFAULTS);

  useEffect(() => {
    if (_cache) { setConfig(_cache); return; }
    getDoc(doc(db, 'configuracion', 'sitio'))
      .then(snap => {
        const data = snap.exists() ? { ...CONFIG_DEFAULTS, ...snap.data() } : CONFIG_DEFAULTS;
        _cache = data;
        setConfig(data);
      })
      .catch(() => setConfig(CONFIG_DEFAULTS));
  }, []);

  return config;
}
